module.exports = __webpack_public_path__ + "static/media/heavy_pound43.33fe5fc8.jpg";